import { render, staticRenderFns } from "./mandate-form.vue?vue&type=template&id=11c4461d&scoped=true&"
import script from "./mandate-form.ts?vue&type=script&lang=ts&"
export * from "./mandate-form.ts?vue&type=script&lang=ts&"
import style0 from "./mandate-form.scss?vue&type=style&index=0&id=11c4461d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c4461d",
  null
  
)

export default component.exports